import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import Table from "../../../Components/ActivityLogs/Table";
import {
  BoxHead,
  Underline,
} from "../../../Components/Styles/PageStyles";

import { useSelector } from "react-redux";
import moment from "moment";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../../Config";
import Loading from "../../../Components/Loading";
import NotFoundModel from "../../../Components/NotFoundModel";

const ActivityLogs = ({ tenantId }) => {

  const { t, i18n } = useTranslation();
  const user = useSelector((state) => state.UserReducer.user);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [apiData, setApiData] = useState([]);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  // const query = `&startDate=${startDate}&endDate=${endDate}&propId=${property?.id}&s=${searchQuery}&t=${filterType}`;
  let query = `&id=${tenantId}`;
  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/activity-log/tenant/list?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [property, startDate, endDate, filterType, searchQuery]);

  return (
    <Wrapper>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Activity Logs
          <Underline />
        </BoxTitle>
      </BoxHead>
      {/* <FilterTableWrapper> */}
      {/* <FilterWrapper>
          <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
            <SearchFilterBox
              options={searchOptions}
              handleFilterChange={handleFilterChange}
              handleClearFilters={handleClearFilters}
            />
            <DateRange
              submitHandler={submitHandler}
              defaultLabel={
                moment(startDate).format("DD MMM yyyy") +
                " - " +
                moment(endDate).format("DD MMM yyyy")
              }
            />
          </div>
           <DownloadBtn type="button" onClick={() => downloadReport()}>
                  {isDownloading ? "Downloading..." : "Download"}
                </DownloadBtn>
        </FilterWrapper> */}
      {!error && !isLoading && apiData && (
        <TableWrapper>
          <Table apiData={error ? [] : apiData} />
          {(error || (apiData && apiData.length === 0)) && !isLoading && <NotFoundModel />}
        </TableWrapper>
      )}
      {/* </FilterTableWrapper> */}

      {/* {error && !isLoading && <NotFoundModel />} */}
      {(isLoading || isRefetching) && <Loading />}
    </Wrapper>
  );
};

const Wrapper = tw.div`space-y-4 mt-2`;
const TableWrapper = tw.h1`my-8 border bg-white rounded-md`;
export const BoxTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;

export default ActivityLogs;
